import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
    createActionAward, editActionAward,
    seeListActionAward, deleteActionAward
} from '../../actions/awardsActions'
import { Translate } from '../../../language';
import inMemoryJWT from '../../../auth/inMemoryJwt';
import Button from '../../../utils/components/Button/Button';

const Actions = ({ history, createActionAward, editActionAward, listActionAwards, seeListActionAward, deleteActionAward, isLoadingListActionAwards }) => {

    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            seeListActionAward()
        })

    }, [])


    const [isEdit, setIsEdit] = useState(false)
    const [idEdit, setIdEdit] = useState('')
    const [indexEdit, setIndexEdit] = useState('')
    const [nameActionAward, setNameActionAward] = useState('')
    const [codeNameActionAward, setCodeNameActionAward] = useState('')
    const [description, setDescription] = useState('')
    const [rankingPoints, setRankingPoints] = useState('')
    const [isValidate, setValidate] = useState(false)
    const [about, setAbout] = useState(1)
    const [ecos, setEcos] = useState(1)
    const [ecosEnabled, setEcosEnabled] = useState(false)
    const [error, setError] = useState({})
    const [isEnable, setEnable] = useState(false)

    const isFocused = (e) => {
        const { name } = e.target;
        setError(prevError => ({
            ...prevError,
            [name]: ''
        }));
    }


    const isEmpty = (e) => {
        if (codeNameActionAward !== '' && nameActionAward !== '' && description !== '' && rankingPoints !== '') {
            setValidate(true)
        }
        const { name, placeholder, value } = e.target;
        if (value.length === 0) {
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es') + placeholder
            }));
        }
        if (value.length !== 0) {

            setError(prevError => ({
                ...prevError,
                [name]: ''
            }));
        }

    }


    return (
        <div className="container-mark-type-admin">
            <div className="new-edit-type-mark-container-admin">
                <div className='title-admin'>{`${isEdit ? 'Editar' : 'Nueva'} acción`}</div>
                <div className="container-inputs-new-mark">
                    <div className="text-input-admin">
                        {'Codigo de la acción:'}
                    </div>
                    <input
                        name='codeNameActionAward'
                        className='inputs-admin'
                        value={codeNameActionAward}
                        onChange={(e) => {
                            setCodeNameActionAward(e.target.value.trimStart())
                            if (codeNameActionAward !== '' && description !== '' && nameActionAward !== '' && rankingPoints !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}

                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                        {...(codeNameActionAward == "ACT023" ? { readOnly: 'success' } : {})}

                    />
                    <div className="text-error text-error-admin">{error.codeNameActionAward}</div>
                    <div className="text-input-admin">
                        {'Nombre:'}
                    </div>
                    <input
                        name='nameActionAward'
                        className='inputs-admin'
                        value={nameActionAward}
                        onChange={(e) => {
                            setNameActionAward(e.target.value.trimStart())
                            if (codeNameActionAward !== '' && description !== '' && nameActionAward !== '' && rankingPoints !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                    />
                   <div className='column'>
                   <div className="text-input-admin">
                        {'Ecos habilitados?'}
                    </div>
                    <input
                        name='rankingPoints'
                        
                        type='checkbox'
                        checked={ecosEnabled}
                        onChange={(e) => {
                            
                            setEcosEnabled(e.target.checked)
                            if (codeNameActionAward !== '' && description !== '' && nameActionAward !== '' && rankingPoints !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                    />
                   </div>
                    <div className="text-input-admin">
                        {'Ecos:'}
                    </div>
                    <input
                        name='rankingPoints'
                        className='inputs-admin'
                        type='number'
                        value={ecos}
                        onChange={(e) => {
                            setEcos(e.target.value.trimStart())
                            if (codeNameActionAward !== '' && description !== '' && nameActionAward !== '' && rankingPoints !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                    />
                    <div className="text-error text-error-admin">{error.nameActionAward}</div>
                    {
                        (codeNameActionAward == "ACT023") && (
                            <>
                                <div className="text-input-admin">
                                    {'Cantidad minima de litros'}
                                </div>

                                <input
                                    name='rankingPoints'
                                    className='inputs-admin'
                                    type='number'
                                    value={about}
                                    onChange={(e) => {
                                        setAbout(e.target.value.trimStart())
                                        if (codeNameActionAward !== '' && description !== '' && nameActionAward !== '' && rankingPoints !== '') {
                                            setValidate(true)
                                        }
                                    }}
                                    onBlur={e => isEmpty(e)}
                                    onFocus={e => isFocused(e)}
                                    onKeyUp={e => isEmpty(e)}
                                />
                            </>
                        )
                    }
                    <div className="text-input-admin">
                        {'Cantidad de punto entregados:'}
                    </div>

                    <input
                        name='rankingPoints'
                        className='inputs-admin'
                        type='number'
                        value={rankingPoints}
                        onChange={(e) => {
                            setRankingPoints(e.target.value.trimStart())
                            if (codeNameActionAward !== '' && description !== '' && nameActionAward !== '' && rankingPoints !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                    />
                    <div className="text-error text-error-admin">{error.rankingPoints}</div>
                    <div className="text-input-admin">
                        {'Descripción:'}
                    </div>
                    <input
                        name='description'
                        className='inputs-admin'
                        value={description}
                        onChange={(e) => {
                            setDescription(e.target.value.trimStart())
                            if (codeNameActionAward !== '' && description !== '' && nameActionAward !== '' && rankingPoints !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                    />
                    <div className="text-error text-error-admin">{error.description}</div>
                    {isEdit ?
                        <div className="content-buttom-create-admin">
                            <button className={`btns-admin  btn-create-edit btns-admin-inactive`} onClick={() => {
                                setCodeNameActionAward('')
                                setNameActionAward('')
                                setRankingPoints('')
                                setDescription('')
                                setEnable(false)
                                setIdEdit('')
                                setIndexEdit('')
                                setIsEdit(false)
                            }}>
                                {Translate('cancel', 'es')}
                            </button>
                            <div className="ml-1 mr-1"></div>
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin  btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => {
                                    editActionAward({
                                        activeEcopoints:ecosEnabled,
                                        ecoPoints:ecos,
                                        actionCode: codeNameActionAward.trim(), name: nameActionAward.trim(), description: description.trim(), actionID: idEdit, rankingPoints: rankingPoints,

                                        ...(codeNameActionAward == "ACT023" && { about: parseInt(about) })
                                    }, indexEdit, history, () => {
                                        setCodeNameActionAward('')
                                        setNameActionAward('')
                                        setRankingPoints('')
                                        setDescription('')
                                        setEnable(false)
                                        setIdEdit('')
                                        setIndexEdit('')
                                        setIsEdit(false)
                                    })

                                }}>
                                {Translate('edit', 'es')}
                            </button>
                        </div>

                        :
                        <div className="content-buttom-create-admin">
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin  btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => {
                                    createActionAward({
                                        activeEcopoints:ecos,
                                        ecoPoints:ecosEnabled,
                                        actionCode: codeNameActionAward.trim(), name: nameActionAward.trim(), description: description.trim(), rankingPoints: rankingPoints }, history, () => {
                                        setCodeNameActionAward('')
                                        setNameActionAward('')
                                        setRankingPoints('')
                                        setDescription('')
                                    })
                                }}>
                                {Translate('create', 'es')}
                            </button>
                        </div>

                    }
                </div>
            </div>
            <div className="see-all-mark-type-admin">
                <div className='title-admin-list'>Acciones existentes</div>
                <div className="scroll-menu">
                    <div className='wrapper-2 column-gap row-gap mt-3'>
                        {isLoadingListActionAwards ? <div>Cargando...</div> :
                            listActionAwards.map((actionAward, index) => (
                                <div key={actionAward._id || index} className="mb-2 row mr-3 ml-2 card-admin">
                                    <div className="mb-2 mr-2 text-bold text-fz-1-5">{actionAward.name}</div>
                                    <div className="mb-2 mr-2">{actionAward.actionCode}</div>
                                    <div className="mb-2 mr-2">{actionAward.description}</div>
                                    <div className="mb-2 mr-2">{actionAward.rankingPoints} puntos</div>
                                    <div className="mb-2 mr-2">{actionAward.ecoPoints} puntos</div>
                                    <div className="column spaceAround">
                                        <Button className="btns-admin ml-1 mr-3" onClick={() => {
                                          setEcos(actionAward.ecoPoints)
                                          setEcosEnabled(actionAward.activeEcopoints)
                                            setCodeNameActionAward(actionAward.actionCode)
                                            setNameActionAward(actionAward.name)
                                            setDescription(actionAward.description)
                                            setRankingPoints(actionAward.rankingPoints)
                                            setIdEdit(actionAward._id)
                                            setEnable(actionAward.isEnable)
                                            setAbout(actionAward.about)
                                            setIndexEdit(index)
                                            setIsEdit(true)
                                        }} text={"Editar"} />
                                        <Button className="btns-admin btns-admin-red" onClick={() => { deleteActionAward(actionAward._id, index) }} text={"Eliminar"} theme={"white"} />

                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        isLoadingListActionAwards: state.awardsAdmin.isLoadingListActionAwards,
        listActionAwards: state.awardsAdmin.listActionAwards
    }
}


export default connect(mapStateToProps, { createActionAward, editActionAward, seeListActionAward, deleteActionAward })(Actions)